import { TournamentBracketMatchGameStatus } from '@okletsplay/core';

export const ACTIVE_MATCH_STATUSES = [
  TournamentBracketMatchGameStatus.Waiting,
  TournamentBracketMatchGameStatus.Running,
  TournamentBracketMatchGameStatus.Ready,
];

export const FEATURE_MATCH_GAME_STATUSES = [
  TournamentBracketMatchGameStatus.Waiting,
  TournamentBracketMatchGameStatus.Ready,
];
